export default "__VITE_ASSET__EdpovBuT__"